<h2 mat-dialog-title>{{getDialogTitle()}}</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="template-name-section">
      <p class="section-label" [innerHTML]="getTemplateNameText()"></p>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Template Name</mat-label>
        <input matInput formControlName="templateName" />
        <mat-error *ngIf="form.get('templateName')?.hasError('required')">
          Template name is required
        </mat-error>
        <mat-error *ngIf="form.get('templateName')?.hasError('minlength')">
          Template names must be at least {{ form.get('templateName')?.errors?.minlength?.requiredLength }} characters long
        </mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="!data.isGlobal" class="clone-option-section">
      <mat-checkbox formControlName="shouldClone">
        <span class="checkbox-label">Create a copy of the current template</span>
      </mat-checkbox>
      <p class="checkbox-description">
        {{getShouldCloneText()}}
      </p>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button *ngIf="data.hasChanges" mat-button (click)="onContinue()">Continue without saving</button>
  <span class="spacer"></span>
  <button mat-button mat-dialog-close>Cancel</button>
  <button 
    mat-raised-button 
    color="primary"
    [disabled]="form.invalid"
    (click)="onSave()">
    Save
  </button>
</mat-dialog-actions>